import type { ContextualColor, SecondaryColor } from '@/components/sgBootstrapReactWrapper';
import type { PersonAmlLevel } from '@/model/mappingCode/personAmlLevel';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

const colorForPersonAmlLevel: { [type in PersonAmlLevel]: ContextualColor | SecondaryColor } = {
  '1': 'success', // low risk
  '2': 'warning', // med-low risk
  '3': 'danger', // med-high risk
  '4': 'danger', // high risk , 'danger' too according to mockups
  '5': 'danger', //
};

type Props = {
  amlLevel: PersonAmlLevel;
};

export const AmlLevelBadge = ({ amlLevel }: Props) => (
  <span
    className={clsx(
      'badge',
      'badge-md',
      'rounded-pill',
      `badge-discreet-${colorForPersonAmlLevel[amlLevel]}`,
    )}
  >
    <FormattedMessage id={`person.amlLevel.${amlLevel}`} />
  </span>
);
